import { AllCountries } from '../config/data/countries';

export const isValidCountryCode = (code: string): code is keyof typeof AllCountries => {
  return code in AllCountries;
};

export const castCountryCode = (code: string): keyof typeof AllCountries => {
  if (!isValidCountryCode(code)) {
    throw new Error('unsupported country code');
  }
  return code;
};

export const getCountryFromCode = (code: string) => {
  if (isValidCountryCode(code)) {
    return AllCountries[code];
  }

  throw new Error('unsupported country code');
};
